import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import HelpView from '@/components/help/help-view'
import { loadCrmPageProps } from '@/lib/crm-page'

type HelpPageProps = Partial<CrmPageProps> & {
    topic: string | null
}

const HelpPage: FC<HelpPageProps> = ({ data, today, topic }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Help" description="Answers to common questions and a way to reach the support team.">
            <PageHeader title="Help" />
            <HelpView initialTopic={topic ?? undefined} />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<HelpPageProps> = async ({ query }) => {
    const topic = typeof query.topic === 'string' ? query.topic : null

    return { props: { ...(await loadCrmPageProps()), topic } }
}

export default HelpPage
